class WuffyCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-wuffy-track]');
    this.previousButton = this.querySelector('[data-wuffy-previous]');
    this.nextButton = this.querySelector('[data-wuffy-next]');

    if (!this.track || !this.previousButton || !this.nextButton) return;

    this.previousButton.addEventListener('click', () => this.move(-1));
    this.nextButton.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    window.addEventListener('resize', () => this.updateButtons(), { passive: true });

    this.#enableDrag();

    requestAnimationFrame(() => this.updateButtons());
  }

  /**
   * Arrastrar con el raton.
   *
   * Con el dedo ya se desliza solo: el carril es overflow-x y el navegador lo
   * resuelve. Lo que no existe en escritorio es agarrar y tirar, y sin eso la
   * unica pista de que hay mas contenido son las flechas.
   *
   * Solo se engancha a raton y lapiz. Si se tocara tambien el dedo, habria que
   * pelear contra el desplazamiento nativo, que va mas fino que cualquier
   * imitacion en JavaScript.
   */
  #enableDrag() {
    let arrastrando = false;
    let partioEn = 0;
    let scrollInicial = 0;
    let movido = 0;
    const UMBRAL = 6;

    this.track.addEventListener('pointerdown', (evento) => {
      if (evento.pointerType === 'touch' || evento.button !== 0) return;
      arrastrando = true;
      movido = 0;
      partioEn = evento.clientX;
      scrollInicial = this.track.scrollLeft;
    });

    this.track.addEventListener('pointermove', (evento) => {
      if (!arrastrando) return;
      const delta = evento.clientX - partioEn;
      if (Math.abs(delta) < UMBRAL && movido === 0) return;
      movido = Math.max(movido, Math.abs(delta));
      // El ajuste obligatorio pelea con el scroll manual y lo deja a saltos.
      this.track.style.scrollSnapType = 'none';
      this.track.setAttribute('data-dragging', '');
      this.track.scrollLeft = scrollInicial - delta;
      evento.preventDefault();
    });

    const soltar = () => {
      if (!arrastrando) return;
      arrastrando = false;
      this.track.removeAttribute('data-dragging');
      this.track.style.scrollSnapType = '';
    };

    this.track.addEventListener('pointerup', soltar);
    this.track.addEventListener('pointercancel', soltar);
    this.track.addEventListener('pointerleave', soltar);

    // Tras arrastrar, el clic que llega detras abriria el producto o pausaria el
    // video sin que nadie lo haya pedido.
    this.track.addEventListener('click', (evento) => {
      if (movido > UMBRAL) {
        evento.preventDefault();
        evento.stopPropagation();
        movido = 0;
      }
    }, true);
  }

  move(direction) {
    const firstItem = this.track.firstElementChild;
    const itemWidth = firstItem?.getBoundingClientRect().width || this.track.clientWidth * 0.8;
    const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const visibleItems = Math.max(1, Math.floor(this.track.clientWidth / (itemWidth + gap)));
    const distance = (itemWidth + gap) * Math.max(1, visibleItems - 1);

    this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  }

  updateButtons() {
    const maximum = this.track.scrollWidth - this.track.clientWidth;
    this.previousButton.disabled = this.track.scrollLeft <= 2;
    this.nextButton.disabled = this.track.scrollLeft >= maximum - 2;
    this.toggleAttribute('data-scrollable', maximum > 3);
  }
}

if (!customElements.get('wuffy-carousel')) {
  customElements.define('wuffy-carousel', WuffyCarousel);
}
